import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Pagination} from 'swiper/modules';
import VerticalBarChart from '../../component/Inc/VerticalBarChart';
import Modal from '../../component/Inc/Modal';
import 'swiper/css';
import 'swiper/css/pagination';
import 'contents/assets/scss/page/main.scss';
import ImgProfile from 'contents/assets/img/@profile.png';
import ImgSample from 'contents/assets/img/img_sample.png';
import ImgBook from 'contents/assets/img/img_book.png';
function Index() {
  const navigate = useNavigate();
  const [modalDate, setModalDate] = useState(false);
  const barChartWidth = '100%';
  const barChartHeight = '210px';
  //barchart labels
  const labels = ['국어', '수학', '영어', '과탐', '사탐'];

  //barchart data
  const data = {
    labels,
    datasets: [
      {
        data: [2, 2, 4, 2, 2, 2, 2, 2, 2, 2, 2, 2],
        backgroundColor: '#2bce71',
        borderColor: '#2bce71',
        borderWidth: 1,
        borderRadius: 10
      },
      {
        data: [4, 4, 4, 4, 4, 2, 4, 4, 4, 4, 4, 4],
        backgroundColor: '#3780ff',
        borderColor: '#3780ff',
        borderWidth: 1,
        borderRadius: 10
      },
      {
        data: [5, 5, 5, 5, 2, 5, 5, 5, 5, 5, 5, 5],
        backgroundColor: '#8f55ff',
        borderColor: '#8f55ff',
        borderWidth: 1,
        borderRadius: 10
      }
    ]
  };

  return (
    <main className="com_container p_main">
      <div className="com_center_wrap">
        <section className="com_pg_container">
          {/* 공지사항 / 이지포토 */}
          <div className="com_pg_container first_w">
            <div className="box_wrap">
              <section className="box box-half">
                <div className="detail_tit dot ">공지사항</div>
                <ul className="board_list_scroll">
                  <li onClick={() => navigate('/Community/Notice')} className="item">
                    <div className="info_box">
                      <p className="date">
                        2022-12-30 <span className="new">NEW</span>
                      </p>
                      <p className="desc">2022년도 이지수능교육 임직원 워크샵 2022년도 이지수능교육 임직원 워크샵</p>
                    </div>
                  </li>
                  {[...Array(6)].map((i, idx) => (
                    <li onClick={() => navigate('/Community/Notice')} className="item" key={idx}>
                      <div className="info_box">
                        <p className="date">2022-12-30</p>
                        <p className="desc">2022년도 이지수능교육 임직원 워크샵 2022년도 이지수능교육 임직원 워크샵</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </section>
              <section className="box box-half sec_easy_photo">
                <div className="detail_tit dot ">이지 포토</div>
                <div className="com_calendar_wrap">
                  <div className="year">
                    <button className="btn btn_prev_gray"></button>
                    <button className="btn_txt">2023</button>
                    <button className="btn btn_next_gray"></button>
                  </div>
                </div>
                <Swiper
                  modules={[Pagination]}
                  loop={true}
                  slidesPerView={1}
                  spaceBetween={0}
                  pagination={{
                    clickable: true
                  }}
                >
                  <SwiperSlide>
                    <div onClick={() => navigate('/Community/Photo')} className="img_list">
                      <div className="item">
                        <img src={ImgSample} alt="이지포토" />
                      </div>
                      <div className="item">
                        <img src={ImgSample} alt="이지포토" />
                      </div>
                      <div className="item">
                        <img src={ImgSample} alt="이지포토" />
                      </div>
                      <div className="item">
                        <img src={ImgSample} alt="이지포토" />
                      </div>
                      <div className="item">
                        <img src={ImgSample} alt="이지포토" />
                      </div>
                    </div>
                    <div className="title">2022, 10, 13 야유회 </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div onClick={() => navigate('/Community/Photo')} className="img_list">
                      <div className="item">
                        <img src={ImgSample} alt="이지포토" />
                      </div>
                      <div className="item">
                        <img src={ImgSample} alt="이지포토" />
                      </div>
                      <div className="item">
                        <img src={ImgSample} alt="이지포토" />
                      </div>
                      <div className="item">
                        <img src={ImgSample} alt="이지포토" />
                      </div>
                      <div className="item">
                        <img src={ImgSample} alt="이지포토" />
                      </div>
                    </div>
                    <div className="title">2022, 10, 13 야유회 </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div onClick={() => navigate('/Community/Photo')} className="img_list">
                      <div className="item">
                        <img src={ImgSample} alt="이지포토" />
                      </div>
                      <div className="item">
                        <img src={ImgSample} alt="이지포토" />
                      </div>
                      <div className="item">
                        <img src={ImgSample} alt="이지포토" />
                      </div>
                      <div className="item">
                        <img src={ImgSample} alt="이지포토" />
                      </div>
                      <div className="item">
                        <img src={ImgSample} alt="이지포토" />
                      </div>
                    </div>
                    <div className="title">2022, 10, 13 야유회 </div>
                  </SwiperSlide>

                  {/* Pagination 요소가 자동으로 생성됩니다. */}
                </Swiper>
              </section>
            </div>
            {/* 이달의 등록회원 */}
            <section className="box sec_member_this_month full">
              <div className="top_row">
                <div className="detail_tit dot">(12월) 이달의 등록 회원</div>
                <ul className="info_list">
                  <li className="item">
                    <div className="txt_box">
                      <p className="tit">신규 가입자</p>
                      <p className="count">450</p>
                    </div>
                    <i className="icon_1"></i>
                  </li>
                  <li className="item">
                    <div className="txt_box">
                      <p className="tit">신규 학습 신청자</p>
                      <p className="count">450</p>
                    </div>
                    <i className="icon_2"></i>
                  </li>
                  <li className="item">
                    <div className="txt_box">
                      <p className="tit">신규 선생님</p>
                      <p className="count">450</p>
                    </div>
                    <i className="icon_3"></i>
                  </li>
                </ul>
                <div className="com_chart_wrap">
                  <div className="chart_body">
                    <div className="chart_content">
                      <VerticalBarChart data={data} width={barChartWidth} height={barChartHeight} />
                    </div>

                    <div className="chart_name">
                      <div className="chart_item">
                        <span className="chart_name_label">10월</span>
                        <div className="chart_box" style={{backgroundColor: '#2bce71'}}></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">11월</span>
                        <div className="chart_box" style={{backgroundColor: '#3780ff'}}></div>
                      </div>

                      <div className="chart_item">
                        <span className="chart_name_label">12월</span>
                        <div className="chart_box" style={{backgroundColor: '#8f55ff'}}></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* 이지 직원 소개 */}
            <section className="box full">
              <div className="detail_tit dot">이지 직원 소개</div>
              <ul className="board_employee_list_scroll">
                {[...Array(6)].map((i, idx) => (
                  <li onClick={() => navigate('/IntroduceMember')} key={idx} className="item">
                    <div className="img_box">
                      <img src={ImgProfile} alt="교사이미지" />
                    </div>
                    <div className="info_box">
                      <p className="tit">
                        홍길동103 <span className="com_point_txt">전략기획실/과장</span>
                      </p>
                      <p className="desc">배정팀, 채용팀 총괄(수학 배정)</p>
                      <p className="desc">
                        입사일 : 2006, 05, 29 (17년차)
                        <br />
                        내선번호 : 1213 / 010-1234-1234
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </section>
          </div>
          <div className="com_pg_container mid_w">
            {/* 이달의 우수 교사 */}
            <section className="box sec_best_teacher full">
              <div className="detail_tit dot">이달의 우수 교사</div>
              <Swiper
                modules={[Pagination]}
                loop={true}
                slidesPerView={1}
                spaceBetween={0}
                pagination={{
                  clickable: true
                }}
              >
                <SwiperSlide>
                  <div onClick={() => navigate('/MonthlyBestTeacher')} className="teacher_wrap">
                    <div className="img_box">
                      <img src={ImgProfile} alt="교사이미지" />
                    </div>
                    <div className="txt_box">
                      <p className="name">김진영</p>
                      <p className="des">정말 눈이오나 앞에서 뒤에서 열심히신 김길동님을 칭찬합니다. 항상 감사드립니다.</p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div onClick={() => navigate('/MonthlyBestTeacher')} className="teacher_wrap">
                    <div className="img_box">
                      <img src={ImgProfile} alt="교사이미지" />
                    </div>
                    <div className="txt_box">
                      <p className="name">김진영</p>
                      <p className="des">정말 눈이오나 앞에서 뒤에서 열심히신 김길동님을 칭찬합니다. 항상 감사드립니다.</p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div onClick={() => navigate('/MonthlyBestTeacher')} className="teacher_wrap">
                    <div className="img_box">
                      <img src={ImgProfile} alt="교사이미지" />
                    </div>
                    <div className="txt_box">
                      <p className="name">김진영</p>
                      <p className="des">정말 눈이오나 앞에서 뒤에서 열심히신 김길동님을 칭찬합니다. 항상 감사드립니다.</p>
                    </div>
                  </div>
                </SwiperSlide>

                {/* Pagination 요소가 자동으로 생성됩니다. */}
              </Swiper>
            </section>

            {/* 새로 오신 이지가족 */}
            <section className="box full">
              <div className="detail_tit dot">새로 오신 이지가족</div>
              <ul className="board_img_list_scroll">
                <li onClick={() => navigate('/NewMember')} className="item flex_row">
                  <div className="img_box">
                    <img src={ImgProfile} alt="교사이미지" />
                  </div>
                  <div className="info_box">
                    <p className="tit">이주영103 (영어)</p>
                    <p className="desc">2022년도 이지수능교육 임직원 워크샵 2022년도 이지수능교육 임직원 워크샵 이지수능교육 임직원 워크샵</p>
                  </div>
                </li>
                {[...Array(4)].map((i, idx) => (
                  <li onClick={() => navigate('/NewMember')} key={idx} className="item flex_row">
                    <div className="img_box">
                      <img src={ImgProfile} alt="교사이미지" />
                    </div>
                    <div className="info_box">
                      <p className="tit">이주영103 (영어)</p>
                      <p className="desc">2022년도 이지수능교육 임직원 워크샵 2022년도 이지수능교육 임직원 워크샵</p>
                    </div>
                  </li>
                ))}
              </ul>
            </section>
            {/* 교재 및 브로셔 안내 */}
            <section className="box full">
              <div className="detail_tit dot">교재 및 브로셔 안내</div>
              <ul className="board_img_list_scroll book">
                {[...Array(6)].map((i, idx) => (
                  <li onClick={() => navigate('/Books/Notice')} key={idx} className="item flex_row">
                    <div className="img_box">
                      <img src={ImgBook} alt="교재" />
                    </div>
                    <div className="info_box">
                      <p className="tit">과학 옹보물 나왔습니다.</p>
                      <p className="desc">2022-03-07</p>
                    </div>
                  </li>
                ))}
              </ul>
            </section>
          </div>

          <div className="com_pg_container last_w">
            {/* 수능  d-day */}
            <section className="box full sec_d_day">
              <div className="top_row">
                <div className="detail_tit dot">수능 D-day</div>
                <div className="date_row">
                  <div className="date">2023, 05, 12</div>
                  <div className="d_day">D-110</div>
                  <button onClick={() => setModalDate(true)} className="btn_calendar_gray"></button>
                </div>
              </div>

              <Modal open={modalDate} close={() => setModalDate(false)} type="pop_d_day">
                <h2 className="pop_tit">수능 날짜 입력</h2>
                <div className="content_container">
                  <div className="com_calendar_wrap">
                    <div className="year ">
                      <button className="btn btn_prev_gray"></button>
                      <button className="btn_txt">2022</button>
                      <button className="btn btn_next_gray"></button>
                    </div>
                  </div>

                  <div className="com_calendar_wrap">
                    <div className="year ">
                      <button className="btn btn_prev_gray"></button>
                      <button className="btn_txt">
                        12 <span className="sub">월</span>
                      </button>
                      <button className="btn btn_next_gray"></button>
                    </div>
                  </div>

                  <div className="com_calendar_wrap">
                    <div className="year ">
                      <button className="btn btn_prev_gray"></button>
                      <button className="btn_txt">
                        20 <span className="sub">일</span>
                      </button>
                      <button className="btn btn_next_gray"></button>
                    </div>
                  </div>
                </div>
                <div className="btn_container">
                  <button className="com_btn orange xs">확인</button>
                </div>
              </Modal>
            </section>
            {/* 수업 통계 */}
            <section className="box full">
              <div className="com_calendar_wrap">
                <div className="year ">
                  <button className="btn btn_prev_gray"></button>
                  <button className="tit"> 3월 수업다수 (국어) 실적</button>
                  <button className="btn btn_next_gray"></button>
                </div>
              </div>
              <div className="com_board_list__scroll">
                <table className="com_board_list">
                  <colgroup>
                    <col width="50" />
                    <col />
                    <col width="95" />
                    <col width="95" />
                    <col width="95" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>순위</th>
                      <th>교사명</th>
                      <th>수업수</th>
                      <th>진행율 (%)</th>
                      <th>유지율 (%)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(12)].map((i, idx) => (
                      <tr key={idx}>
                        <td>{idx + 1}</td>

                        <td>김교사 103</td>
                        <td>104</td>
                        <td>91</td>
                        <td>100</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
            {/* 캠페인 / 시상 / 인사 */}
            <section className="box full">
              <div className="detail_tit dot ">캠페인 / 시상 / 인사</div>
              <ul className="board_campain_list_scroll">
                <li onClick={() => navigate('/Award')} className="item">
                  <div className="info_box">
                    <p className="date">2022-12-30</p>
                    <p className="desc">
                      김길동님이 오랜 경력과 능력으로 진급하였습니다.<span className="new">NEW</span>
                    </p>
                  </div>
                </li>
                {[...Array(15)].map((i, idx) => (
                  <li onClick={() => navigate('/Award')} className="item" key={idx}>
                    <div className="info_box">
                      <p className="date">2022-12-30</p>
                      <p className="desc">김길동님이 오랜 경력과 능력으로 진급하였습니다.</p>
                    </div>
                  </li>
                ))}
              </ul>
            </section>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Index;
